// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import FlashMessage from 'components/FlashMessage';
import { removeFlashMessage as removeFlashMessageRaw } from '../redux/main/actions/flashMessages';

type Props = {
  flashMessages: Array<FlashMessageType>,
  removeFlashMessage: Function
};

const FlashMessageContainer = React.memo<Props>(
  ({ flashMessages, removeFlashMessage }: Props) => (
    <div id="flash-message-container">
      {flashMessages.map(flashMessage => (
        <FlashMessage
          key={flashMessage.id}
          flashMessage={flashMessage}
          removeMessage={() => removeFlashMessage(flashMessage.id)}
        />
      ))}
    </div>
  )
);

const mapStateToProps = ({ flashMessages }) => ({ flashMessages });

export default connect<Props, {||}, _, _, _, _>(
  mapStateToProps,
  {
    removeFlashMessage: removeFlashMessageRaw
  }
)(FlashMessageContainer);
